var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tbody", [
    _c("tr", { attrs: { "data-test": "realintention-realintention" } }, [
      _c(
        "td",
        {
          staticClass: "boss-table-data text-left pega-white-space-normal",
          attrs: { "data-test": "content" },
        },
        [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data text-center",
          attrs: { "data-test": "createDate" },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("formatDate")(_vm.realIntention.createDate)) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data text-center",
          attrs: { "data-test": "updateDate" },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("formatDate")(_vm.realIntention.updateDate)) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "boss-table-data" }, [
        _c("button", {
          staticClass: "boss-icon-pencil",
          attrs: { "data-test": "edit" },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "realIntentionEdit",
                params: { realIntentionId: _vm.realIntention.id },
              })
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "boss-table-data" }, [
        _c("button", {
          staticClass: "boss-icon-trash",
          attrs: { "data-test": "remove" },
          on: {
            click: function ($event) {
              return _vm.doRemove(_vm.realIntention.id)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "boss-table-data" }, [
        _c(
          "button",
          {
            staticClass: "boss-button",
            attrs: { type: "button", "data-test": "pc-preview-button" },
            on: { click: _vm.windowOpenPcPreview },
          },
          [_vm._v("\n        PC版\n      ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "boss-button",
            attrs: { type: "button", "data-test": "sp-preview-button" },
            on: { click: _vm.windowOpenSpPreview },
          },
          [_vm._v("\n        スマホ版\n      ")]
        ),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "boss-table-data" }, [
        _c("div", { staticClass: "switch toggle-switch" }, [
          _c("input", {
            staticClass: "toggle-input",
            attrs: {
              id: "toggle-" + _vm.realIntention.id,
              "data-test": "toggle",
              type: "checkbox",
            },
            domProps: { checked: _vm.realIntention.isPublished },
            on: {
              change: function ($event) {
                return _vm.changeDisplayStatus(
                  _vm.realIntention.id,
                  _vm.realIntention.isPublished
                )
              },
            },
          }),
          _vm._v(" "),
          _c("label", {
            staticClass: "toggle-label",
            attrs: { for: "toggle-" + _vm.realIntention.id },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }